import { payStaProxy } from './index';
// proxy/pay/sta/

/* [ 현황 - pay ]  */
// 급여내역 목록조회
function getPayList(params) {
  return payStaProxy.get('pay/search/term/pay/emp/list', { params });
}

// 급여명세서 항목조회
function getPayEleList(params) {
  return payStaProxy.get('pay/search/term/ele/emp/list', { params });
}

// 급여명세서 계좌조회
function getPayAccInfo() {
  return payStaProxy.get('pay/search/term/acc/emp/list');
}

// 급여명세서 계산방법조회
function getPayFormulaList(params) {
  return payStaProxy.get('pay/search/term/pay/emp/formula/list', {
    params,
  });
}

//기타내역
function getPayEtcList(params) {
  return payStaProxy.get('pay/search/term/pay/emp/etc/list', {
    params,
  });
}

// 급여명세서 계산방법조회
function getPayFormulaListNew(params) {
  return payStaProxy.get('pay/search/term/pay/formula/list/new', {
    params,
  });
}

export {
  getPayList,
  getPayEleList,
  getPayAccInfo,
  getPayFormulaList,
  getPayEtcList,
  getPayFormulaListNew,
};
